import React from 'react';

const Testimonial: React.FC = () => (
  <div className="testimonial">
    <div className="testimonial-content">
      <div className="testimonial-quote">
        <p>"El mejor café que he probado y los postres son una delicia. El ambiente es acogedor y el servicio excepcional."</p>
      </div>
      <div className="testimonial-author">
        <div className="author-avatar">A</div>
        <div className="author-info">
          <span className="author-name">Ana María González</span>
          <span className="author-role">Cliente frecuente</span>
        </div>
      </div>
    </div>
  </div>
);

export default Testimonial;